<template>
    <div>
        <el-row :gutter="20" style="margin-bottom: 20px">
            <el-col :span="12">
                &nbsp;
                <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true" v-if="$isFullAdmin">{{$t('common.create')}}</el-button>
                <el-button icon="el-icon-download" @click="download" v-if="$isAdmin">{{$t('common.export')}}</el-button>
            </el-col>
            <el-col :span="4">
                <product-selector v-model="filter.productId"></product-selector>
            </el-col>
            <el-col :span="8">
                <el-input v-model="filter.text" prefix-icon="el-icon-search"></el-input>
            </el-col>
        </el-row>

        <el-table :data="codes" v-loading="loading" size="mini" class="orders-table tablewithshading">
            <el-table-column prop="code" :label="$t('common.code')" width="150"></el-table-column>
            <el-table-column prop="description" :label="$t('common.description')"></el-table-column>
            <el-table-column prop="product" :label="$t('common.product')"></el-table-column>
            <el-table-column :label="$t('common.operations')" fixed="right" width="160">
                <template slot-scope="scope">
                    <el-button size="mini" @click="editCode(scope.row.id)">
                        <i class="el-icon-edit"></i>
                    </el-button>
                    <el-button size="mini" type="danger" @click="deleteCode(scope.row.id)" v-if="$isFullAdmin">
                        <i class="el-icon-delete"></i>
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination class="pager" v-if="total !== 0" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="15" layout="total, prev, pager, next" :total="total">
        </el-pagination>
        <create-update-complaint-code-dialog :codeId="codeToEdit" :visible="dialogVisible" @dialogClosed="editFinished" @save="appendCode"></create-update-complaint-code-dialog>
    </div>
</template>

<script>
    import CreateUpdateComplaintCodeDialog from "./CreateUpdateComplaintCodeDialog";
    import { ProductSelector, PartSelector } from "@/app/shared/components";
    import api from "../api";

    export default {
        name: "complaint-code-list",
        components: {
            CreateUpdateComplaintCodeDialog,
            ProductSelector,
            PartSelector
        },
        data() {
            return {
                codes: [],
                loading: true,
                dialogVisible: false,
                codeToEdit: null,
                filter: {
                    productId: undefined,
                    text: undefined
                },
                currentPage: 1,
                total: 0
            };
        },
        created() {
            this.loadCodes();
        },
        watch: {
            filter: {
                deep: true,
                handler: function (val) {
                    this.loadCodes();
                }
            }
        },
        methods: {
            download() {
                api.download(this.filter);
            },
            loadCodes() {
                this.loading = true;
                api
                    .getCodes(this.currentPage, this.filter.productId, this.filter.text)
                    .then(response => {
                        this.loading = false;
                        this.codes = response.data.items;
                        this.total = response.data.total;
                    });
            },
            appendCode(event) {
                if (event.new) {
                    this.codes.push(event.data);
                    this.total += 1;
                } else {
                    var toUpdateIndex = this.codes.findIndex(x => x.id == event.id);
                    if (toUpdateIndex >= 0) {
                        Object.assign(this.codes[toUpdateIndex], event.data);
                    }
                }
            },
            handleCurrentChange(page) {
                this.currentPage = page;
                this.loadCodes();
            },
            editCode(id) {
                this.codeToEdit = id;
                this.dialogVisible = true;
            },
            editFinished() {
                this.codeToEdit = null;
                this.dialogVisible = false;
            },
            deleteCode(id) {
                this.$confirm(this.$t('common.thisWillDeleteCodeContinue'), "Warning", {
                    confirmButtonText: this.$t('common.OK'),
                    cancelButtonText: this.$t('common.cancel'),
                    type: "warning"
                })
                    .then(() => {
                        api.deleteCode(id).then(() => {
                            this.loadCodes();
                            this.$message({
                                type: "success",
                                message: this.$t('common.deleteCompleted')
                            });
                        });
                    })
                    .catch(_ => { });
            }
        }
    };
</script>


// WEBPACK FOOTER //
// ClientApp/app/masters/complaintcodes/components/ComplaintCodeList.vue